import React from "react";
import * as S from "./Smartengagebanner.styles";

interface IGotribe {
  cta_url: string;
  cta_type: string;
  img_url: string;
  setWidth: string;
}

const GoTribeBenifitsBannerUI: React.FC<IGotribe> = ({
  cta_type,
  cta_url,
  img_url = "",
  setWidth = ''
}) => {
  const navigateToPage = () => {
    if (cta_type === "no_cta") return;
    if (cta_url) {
      window.location.href = cta_url;
    }
  };
  return (
    <S.BannerWrapper onClick={() => navigateToPage()}>
      <S.BannerImg src={img_url} width={setWidth}></S.BannerImg>
    </S.BannerWrapper>
  );
};

export default React.memo(GoTribeBenifitsBannerUI);
